module.exports = __webpack_public_path__ + "static/media/sunset.d6ddb14c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/sunset.jpg
// module id = 235
// module chunks = 0